import React, { type ComponentPropsWithoutRef } from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyAfterPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import { JiraIssueCreateErrorBoundary } from '@atlassian/jira-issue-create-analytics-common/src/ui/jira-issue-create-error-boundary/index.tsx';
import type { ControllerFull } from '@atlassian/jira-platform-services-user-current/src/types.tsx';
import type { User } from '@atlassian/jira-shared-types/src/rest/jira/user.tsx';
import type { WatchersConfig } from '../services/types.tsx';

const AsyncWatchers: LazyComponent<
	({
		projectKey,
		watchers,
		setWatchers,
		canManageWatchers,
		currentUser,
		isWatching,
		shouldRenderInDropdown,
	}: {
		projectKey: string;
		watchers: User[];
		setWatchers: (users: User[]) => void;
		currentUser: ControllerFull['data']['user'];
		isWatching?: boolean;
		shouldRenderInDropdown?: boolean;
	} & WatchersConfig) => React.JSX.Element
	// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
> = lazyAfterPaint(
	() => import(/* webpackChunkName: "async-watchers-in-issue-create-modal" */ './main'),
	{ ssr: false },
);

const Watchers = (props: ComponentPropsWithoutRef<typeof AsyncWatchers>): React.JSX.Element => (
	<JiraIssueCreateErrorBoundary
		id="async.jira-issue-create-watchers"
		packageName="jiraIssueCreateWatchers"
	>
		<Placeholder name="issue-create-watchers-modal" fallback={null}>
			<AsyncWatchers {...props} />
		</Placeholder>
	</JiraIssueCreateErrorBoundary>
);

export default Watchers;
